type IndexableObject<T> = { [key: string]: IndexableObject<T> | T }

export const getValueByPath = <T>(obj: IndexableObject<T>, path: string) => {
  return path
    .split('.')
    .reduce((acc, part) => acc && (acc as IndexableObject<T>)[part], obj as IndexableObject<T> | T)
}
